export default __webpack_public_path__ + "static/media/bol_scan_1.a8a36c3b.svg";